/* Copyright (c) 2015, Oracle and/or its affiliates. All rights reserved.*/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

define('helpers/stringUtils',['ojs/ojcore', 'jquery'], function ($) {
  var stringUtilsModel = {
    compare: function compare(string1, string2, ignoreCase, useLocale) {
      // returns true or false
      if (ignoreCase) {
        if (useLocale) {
          string1 = string1.toLocaleLowerCase();
          string2 = string2.toLocaleLowerCase();
        } else {
          string1 = string1.toLowerCase();
          string2 = string2.toLowerCase();
        }
      }

      return string1 === string2;
    },
    contains: function contains(string, substring, ignoreCase, useLocale) {
      // returns true or false // substring : use | for OR, + for AND
      if (ignoreCase) {
        if (useLocale) {
          string = string.toLocaleLowerCase();
          substring = substring.toLocaleLowerCase();
        } else {
          string = string.toLowerCase();
          substring = substring.toLowerCase();
        }
      }

      return string.includes(substring);
    },
    escapeHtml: function escapeHtml(str) {
      // make HTML tags displayable 
      str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
      return str;
    },
    nobreak: function nobreak(str) {
      // replace normal space with non-break space, useful for labels in buttons, column headings etc
      str = str.replace(/ /g, '&nbsp;');
      return str;
    },
    camelCase: function camelCase(str) {
      return str.replace(/(-.)/g, function (x) {
        return x[1].toUpperCase();
      });
    },
    labelize: function labelize(str) {
      if (str === str.toUpperCase()) {
        return str;
      }

      var str = stringUtilsModel.camelCase(str).replace(/([^A-Z])([A-Z])/g, "$1 $2");
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    stripNum: function stripNum(str) {
      return str.replace(/[0-9]/g, '');
    },
    pad: function pad(str, intensity, leftOnly, rightOnly) {
      // put some breathing space, good for button text
      var sp = '&nbsp;';
      if (intensity) sp = Array(intensity + 1).join(sp);
      if (leftOnly) str = sp + str;
      if (rightOnly) str = str + sp;
      if (!leftOnly && !rightOnly) str = sp + str + sp;
      return str;
    },
    replaceURLQueryParam: function replaceURLQueryParam(param) {
      var newVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var urlStr = arguments.length > 2 ? arguments[2] : undefined;
      var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
      var query = urlStr.replace(regex, "$1").replace(/&$/, '');
      return query + (query.indexOf('?') > -1 ? "&" : "?") + (param + "=" + newVal);
    },
    removeURLQueryParam: function removeURLQueryParam(urlStr) {
      var regex, matches;

      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _params = params; _i < _params.length; _i++) {
        var param = _params[_i];
        regex = new RegExp("(\\?" + param + "=[^&]*)(&?)|(&" + param + "=[^&]*)&?");
        matches = regex.exec(urlStr);

        if (matches !== null) {
          urlStr = urlStr.replace(matches[1], ''); //if matches first param, removing string '?param=val'

          if (matches[2] === '&') {
            urlStr = urlStr.replace(matches[2], '?'); //if matches first param and if more parameters exist, replacing & with ?
          }

          urlStr = urlStr.replace(matches[3], ''); //if not first and matches any subsequent param, removing leading &
        }
      }

      return urlStr;
    },
    parseUrl: function parseUrl(url) {
      var URLParser = function (document) {
        var PROPS = 'protocol hostname host pathname port search hash href'.split(' ');

        var self = function self(url) {
          this.aEl = document.createElement('a');
          this.parse(url);
        };

        self.prototype.parse = function (url) {
          this.aEl.href = url;

          if (this.aEl.host == "") {
            this.aEl.href = this.aEl.href;
          }

          PROPS.forEach(function (prop) {
            switch (prop) {
              case 'hash':
                this[prop] = this.aEl[prop].substr(1);
                break;

              default:
                this[prop] = this.aEl[prop];
            }
          }, this);

          if (this.pathname.indexOf('/') !== 0) {
            this.pathname = '/' + this.pathname;
          }

          this.requestUri = this.pathname + this.search;
        };

        self.prototype.toObj = function () {
          var obj = {};
          PROPS.forEach(function (prop) {
            obj[prop] = this[prop];
          }, this);
          obj.requestUri = this.requestUri;
          return obj;
        };

        self.prototype.toString = function () {
          return this.href;
        };

        return self;
      }(document);

      return new URLParser(url).toObj();
    },

    /* 
        dateTime: date as Date object (or) time as number (or) date as string
        options: pattern as a string (or) OJET options for DateTime Converter
        Refer to all available patterns & options at
        http://www.oracle.com/webfolder/technetwork/jet/jsdocs/OraDateTimeConverter.html 
    */
    formatDateTime: function formatDateTime(dateTime, options) {
      var date = dateTime;

      if (typeof dateTime === "number" || typeof dateTime === "string") {
        date = new Date(dateTime);
      }

      var _options = {};

      if (typeof options === "string") {
        _options.pattern = options;
      } else if (options !== "undefined" && _typeof(options) === "object") {
        _options = options;
      }

      var converterFactory = oj.Validation.converterFactory("datetime");
      var converter = converterFactory.createConverter(_options);
      return converter.format(oj.IntlConverterUtils.dateToLocalIso(date));
    }
  };
  return stringUtilsModel;
});
